import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

const CACHE_KEY = "smartly_geo_city";

export function useGeoCity(): string | null {
  const [city, setCity] = useState<string | null>(() => {
    try {
      return sessionStorage.getItem(CACHE_KEY);
    } catch {
      return null;
    }
  });

  useEffect(() => {
    // If already cached, skip fetch
    try {
      if (sessionStorage.getItem(CACHE_KEY)) return;
    } catch {
      // sessionStorage unavailable, proceed with fetch
    }

    const controller = new AbortController();

    supabase.functions
      .invoke("geoip-lookup", { method: "GET" })
      .then(({ data, error }) => {
        if (controller.signal.aborted) return;
        if (error || !data?.city) return;

        setCity(data.city);
        try {
          sessionStorage.setItem(CACHE_KEY, data.city);
        } catch {
          // ignore
        }
      });

    return () => controller.abort();
  }, []);

  return city;
}
